export default __webpack_public_path__ + "be257b54b99780b42d93991c8a7ca4db.svg";